"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const _tagged_template_literal = require("@swc/helpers/_/_tagged_template_literal");
function _templateObject() {
    const data = _tagged_template_literal._([
        "\n  fragment OrderByOptions on PlpOrderingDefinition {\n    __typename\n    displayText\n    orderBy\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.orderByOptions = void 0;
var _fetching = require("@ori/fetching");
const orderByOptions = exports.orderByOptions = (0, _fetching.gql)(_templateObject());
